import { CLIENT_EVENT_ACCORDION_EXPAND_DISABLED } from "src/config/featureFlags";
import { Accordion } from "src/lib/components/composition";
import { EventAccordion } from "src/lib";
import { IDetailsProps } from "./types";

const Details = ({ commitment, open, isOpen, toggleAccordion, clientOpportunities = [] }: IDetailsProps) => {
    return (
        <Accordion.Details open={open}>
            {commitment.clients.map((client: any, idx: any) => {
                const accordionId = `${commitment.due_date}-${idx}-${client?.client?.name ?? idx}`;
                const accordionIsOpen = CLIENT_EVENT_ACCORDION_EXPAND_DISABLED
                    ? false
                    : isOpen(accordionId);
                return (
                    <EventAccordion.Root sx={{ mt: 3 }} key={accordionId}>
                        <EventAccordion.Summary
                            key={`${accordionId}-summary`}
                            commitment={commitment}
                            client={client}
                            open={accordionIsOpen}
                            onToggle={() => {
                                if (CLIENT_EVENT_ACCORDION_EXPAND_DISABLED) return;
                                toggleAccordion(accordionId);
                            }}
                        />
                        <EventAccordion.Details
                            key={`${accordionId}-details`}
                            open={accordionIsOpen}
                            client={client}
                            accordionId={accordionId}
                        />
                    </EventAccordion.Root>
                );
            })}
            {clientOpportunities.map((item: any, idx: number) => {
                const clientKey = item?.client?.client?.account ?? idx
                const accordionId = `opportunity-${commitment.due_date}-${clientKey}-${idx}`
                const accordionIsOpen = CLIENT_EVENT_ACCORDION_EXPAND_DISABLED
                    ? false
                    : isOpen(accordionId)
                return (
                    <EventAccordion.Root sx={{ mt: 3 }} key={accordionId}>
                        <EventAccordion.Summary
                            key={`${accordionId}-summary`}
                            client={item.client}
                            opportunities={item.opportunities}
                            summaryType="opportunity"
                            open={accordionIsOpen}
                            onToggle={() => {
                                if (CLIENT_EVENT_ACCORDION_EXPAND_DISABLED) return;
                                toggleAccordion(accordionId);
                            }}
                        />
                        <EventAccordion.Details
                            key={`${accordionId}-details`}
                            client={item.client}
                            variant="opportunity"
                            opportunities={item.opportunities}
                            open={accordionIsOpen}
                            accordionId={accordionId}
                        />
                    </EventAccordion.Root>
                )
            })}
        </Accordion.Details>
    );
};

export { Details };
